var _path, _path2, _path3, _path4, _path5, _path6, _path7, _defs;
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPricesIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 18H8V20H12V18Z",
    fill: "url(#paint0_linear_1277_458)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18 18H14V20H18V18Z",
    fill: "url(#paint1_linear_1277_458)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12 14H8V16H12V14Z",
    fill: "url(#paint2_linear_1277_458)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M18 22H14V24H18V22Z",
    fill: "url(#paint3_linear_1277_458)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M24 14H20V16H24V14Z",
    fill: "url(#paint4_linear_1277_458)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M24 22H20V24H24V22Z",
    fill: "url(#paint5_linear_1277_458)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M27 3H5C4.46977 3.00066 3.96145 3.21159 3.58652 3.58652C3.21159 3.96145 3.00066 4.46977 3 5V27C3.00066 27.5302 3.21159 28.0386 3.58652 28.4135C3.96145 28.7884 4.46977 28.9993 5 29H27C27.5302 28.9993 28.0386 28.7884 28.4135 28.4135C28.7884 28.0386 28.9993 27.5302 29 27V5C28.9993 4.46977 28.7884 3.96145 28.4135 3.58652C28.0386 3.21159 27.5302 3.00066 27 3ZM27 5V9H5V5H27ZM5 27V11H27V27H5Z",
    fill: "url(#paint6_linear_1277_458)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1277_458",
    x1: 29.0188,
    y1: 16,
    x2: 3,
    y2: 16,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0D1775"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1383F4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1277_458",
    x1: 29.0188,
    y1: 16,
    x2: 3,
    y2: 16,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0D1775"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1383F4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_1277_458",
    x1: 29.0188,
    y1: 16,
    x2: 3,
    y2: 16,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0D1775"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1383F4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_1277_458",
    x1: 29.0188,
    y1: 16,
    x2: 3,
    y2: 16,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0D1775"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1383F4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_1277_458",
    x1: 29.0188,
    y1: 16,
    x2: 3,
    y2: 16,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0D1775"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1383F4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_1277_458",
    x1: 29.0188,
    y1: 16,
    x2: 3,
    y2: 16,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0D1775"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1383F4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_1277_458",
    x1: 29.0188,
    y1: 16,
    x2: 3,
    y2: 16,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0D1775"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1383F4"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPricesIcon);
export default __webpack_public_path__ + "static/media/pricesIcon.2fd4677f207e602276f074d2870d935a.svg";
export { ForwardRef as ReactComponent };